import { SocialPlatform } from '@/core/types/profile-modules';

export const SOCIAL_PLATFORMS: Array<{ value: SocialPlatform; label: string }> =
  [
    { value: SocialPlatform.INSTAGRAM, label: 'Instagram' },
    { value: SocialPlatform.LINKEDIN, label: 'LinkedIn' },
    { value: SocialPlatform.X, label: 'X' },
    { value: SocialPlatform.TIKTOK, label: 'TikTok' },
    { value: SocialPlatform.YOUTUBE, label: 'YouTube' },
    { value: SocialPlatform.FACEBOOK, label: 'Facebook' },
    { value: SocialPlatform.GITHUB, label: 'GitHub' },
    { value: SocialPlatform.BEHANCE, label: 'Behance' },
    { value: SocialPlatform.DRIBBBLE, label: 'Dribbble' },
    { value: SocialPlatform.PINTEREST, label: 'Pinterest' },
    { value: SocialPlatform.SNAPCHAT, label: 'Snapchat' },
    { value: SocialPlatform.TWITCH, label: 'Twitch' },
    { value: SocialPlatform.CUSTOM, label: 'Andere' },
  ];
